let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dXOpn")).then(() => parcelRequire('kb00V'));